<template>
  <span v-if="!isManager">
    {{ estimate.estimatePrice.getSystemPrice(estimate.dealTypeCode).format() }}
  </span>
  <span v-else>
    {{ estimate.subtotal.getSystemPrice(estimate.dealTypeCode).format() }}
  </span>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { Pricing } from "@/app/domain";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useUserStore } from "@/stores/userStore";
import { useDeliveryStore } from "@/stores/new/delivery.store";
import { useInstallationStore } from "@/stores/new/installation.store";
import { usePartitionStore } from "@/stores/new/partition.store";
import { PricingService } from "@/app/services/pricing.service";
import { useOverheadStore } from "@/stores/new/overhead.store";

const userStore = useUserStore();
const estimateStore = useNewEstimateStore();

const estimate = computed(() => estimateStore.estimate);
const isManager = computed(() => userStore.isSalesManager);

const deliveryStore = useDeliveryStore();
const newInstallationStore = useInstallationStore();
const pricingService = new PricingService();
const partitionStore = usePartitionStore();
const overheadStore = useOverheadStore();

const activeOverhead = computed(() => overheadStore.activeOverhead);
const activeParition = computed(() => partitionStore.activePartitions);

watch(
  () => [
    activeOverhead.value?.sum,
    deliveryStore.totalDeliveryPrice,
    newInstallationStore.totalInstallationSum,
    activeParition.value?.sum,
  ],
  () => {
    const summaryTotalPrice =
      pricingService.calculateCurrentSummaryTotalPrice();

    estimateStore.estimate.estimatePrice = new Pricing(0, 0, 0);
    estimateStore.estimate.estimatePrice = new Pricing(
      summaryTotalPrice.price,
      summaryTotalPrice.priceB2C,
      summaryTotalPrice.priceB2B,
    );
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<style lang="scss" scoped></style>
